// easy-peasy-equal-heights => https://benhowdle.im/easy-peasy-equal-heights.html

function sameHeights(selector) {
  var selector = selector || '[data-js="equal-heights"]',
      query = document.querySelectorAll(selector),
      elements = query.length,
      max = 0;
  if (elements) {
    var temp_elements = elements;
    while (temp_elements--) {
      var temp_elements = query[temp_elements];
        temp_elements.style.height = 'auto';
      }
      setTimeout(function(){}, 100);
      while (elements--) {
          var element = query[elements];
          if (element.offsetHeight > max) {
              max = element.offsetHeight;
          }
      }
      elements = query.length;
      while (elements--) {
          var element = query[elements];
          element.style.height = max + 'px';
      }
  }
}

if ('addEventListener' in window) {
  window.addEventListener('resize', function(){
      sameHeights();
  });
  window.addEventListener('load', function(){
      sameHeights();
  });
}
